import Vue from 'vue'
import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    pageIdByOta: '',
    collectionSetting: null,
    navSetting: null,
    itemProperty: null,
    category: null,
    myCollectionSetting: null,
    detailGallery: null,
    detailVideo: null,
    toastMessage: null,
    megaMenu: false,
    myCollectionItemIds: null
  },
  mutations: {
    setCollectionSetting (state, data) {
      state.collectionSetting = data || null
    },
    setCollectionNavSetting (state, data) {
      state.navSetting = data || null
    },
    setItemProperty (state, data) {
      state.itemProperty = data || null
    },
    setCollectionCategory (state, data) {
      state.category = data || null
    },
    setMyCollectionSetting (state, data) {
      state.myCollectionSetting = data || null
    },
    setDetailGallery (state, data) {
      state.detailGallery = data || null
    },
    setDetailVideo (state, data) {
      state.detailVideo = data || null
    },
    setToastMessage (state, data) {
      state.toastMessage = data || null
    },
    setMegaMenu (state, data) {
      state.megaMenu = data || false
    },
    setMyCollectionItemIds (state, ids) {
      state.myCollectionItemIds = ids || null
    }
  },
  actions: {
    async getCollectionPageId ({ state }) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-collection-service',
          func: 'get-collection-pageid',
          siteid: siteid,
          spaceid: spaceid
        })
        state.pageIdByOta = (res && res.data && res.data.message && res.data.message.pageId) || ''
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 마이콜렉션 담기
    async addCollection ({ state }, data) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      const staff = siteInfo.staff
      try {
        const res = await axios.post(`${API.ORDER_URL}/v1/api/order/${siteid}/${spaceid}`, {
          cmd: 'sc-service',
          func: 'set-submit',
          // pageId: data.pageId,
          catCode: 'system_collection_service',
          userInfo: {
            ...ota && {
              ota: ota
            }
          },
          ...staff && {
            requester: `${staff}.${siteid}`
          },
          payload: [
            {
              collectionCategory: data.collectionCategory,
              collectionItemId: data.collectionItemId
            }
          ]
        })
        console.log(res)
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 마이콜렉션 리스트 호출
    async getMyCollectionItems ({ state, commit }, data) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const ota = siteInfo.k
      if (ota) {
        try {
          const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
            cmd: 'sc-collection-service',
            func: 'get-my-collection-item',
            siteid: siteid,
            ota: ota,
            pageId: data.pageId,
            // ...data.collectionCategory && {
            //   collectionCategory: data.collectionCategory
            // }
          })
          /**
           * 마이콜렉션 전체 호출이면 스토어에 저장
           * 콜렉션페이지에서 toggle 하는데 사용
           */
          if (!data.collectionCategory) {
            if (res && res.data && res.data.message) {
              const ids = res.data.message.map(x => x.collectionItemId)
              commit('setMyCollectionItemIds', [...new Set(ids)])
            }
          }
          return res.data
        } catch (ex) {
          // console.log(ex)
          return ex && ex.response
        }
      }
    },
    // 마이콜렉션 아이템 삭제
    async removeMyCollectionItem ({ state }, data) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const ota = siteInfo.k
      const staff = siteInfo.staff
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-collection-service',
          func: 'remove-my-collection-item',
          siteid: siteid,
          ota: ota,
          pageId: data.pageId,
          collectionCategory: data.collectionCategory,
          orderItemId: data.orderItemId,
          ...staff && {
            requester: `${staff}.${siteid}`
          },
        })
        return res
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
  },
  getters: {
    useCollectionPage: state => state.collectionSetting && state.collectionSetting.useCollection !== false,
    getCollectionSetting: state => state.collectionSetting && state.collectionSetting.collectionPage,
    getPointColor: state => state.collectionSetting && state.collectionSetting.collectionPage && state.collectionSetting.collectionPage.pointColor,
    getCategoryListAll: state => state.category,
    getCollectionMainPage: state => {
      const setting = state.collectionSetting
      const cover = setting && setting.usePageCover
      const intro = setting && setting.usePageIntro
      const main = setting && setting.usePageMain
      return cover && main && main.isActive
      ? {
        ...cover.isActive && {
          cover: cover.image
        },
        ...intro.isActive && {
          intro: intro.image
        },
        image: main.image
      }
      : null
    },
    getPageFrame: state => {
      const setting = state.collectionSetting
      const frame = setting && setting.usePageFrame
      return frame && frame.isActive && frame.size
    },
    getCollectionNavSetting: state => {
      const navSetting = state.navSetting
      return {
        navTop: navSetting && navSetting.top,
        category: navSetting && navSetting.category,
        icons: {
          back: navSetting && navSetting.backIcon,
          menu: navSetting && navSetting.menuIcon,
          myCollection: navSetting && navSetting.myCollectionIcon,
        }
      }
    },
    // 카테고리바 구성에 필요한 배열
    getSiblingsCategory: state => (categoryId, isSubCategory) => {
      const categoryList = state.category && findCategoryListById(state.category, categoryId)
      // categoryId가 일치하는 요소의 siblings 배열
      function findCategoryListById (data, targetId) {
        if (!targetId) return data
        for (const item of data) {
          if (item.categoryId === targetId) {
            return data
          }
          if (item.subCategory) {
            const found = findCategoryListById(item.subCategory, targetId)
            if (found) return found
          }
        }
        return null
      }
      // 카테고리 메인이면 subCategory list가, 리스트 페이지면 Self siblings list가 리턴
      function findTargetAndSiblings (data, targetId) {
        if (!targetId) return data
        for (const item of data) {
          if (item.categoryId === targetId) {
            return { target: item, siblings: data }
          }
          if (item.subCategory) {
            const result = findTargetAndSiblings(item.subCategory, targetId)
            if (result && result.target) return result
          }
        }
        // 찾지 못했을 경우 fallback
        return { target: null, siblings: data }
      }
      if (!categoryList) return []

      // targetId가 없으면 1뎁스 리턴
      if (!categoryId) return categoryList

      const { target, siblings } = findTargetAndSiblings(categoryList, categoryId)
      // isSubCategory가 true이고, target의 subCategory가 있으면 반환
      if (isSubCategory && target && target.subCategory) {
        return target.subCategory
      }

      // 그렇지 않으면 siblings 반환
      return siblings
    },
    // 전체 카테고리에서 카테고리Id 일치하는 요소 반환
    getCategoryById: state => categoryId => {
      function findCategoryById (data, targetId) {
        for (const item of data) {
          if (item.categoryId === targetId) {
            return item
          }
          if (item.subCategory) {
            const found = findCategoryById(item.subCategory, targetId)
            if (found) return found
          }
        }
        return null
      }
      return state.category && findCategoryById(state.category, categoryId)
    },
    // 전체 카테고리에서 바로 상위 카테고리Id를 반환 (더이상 없으면 'main')
    getParentCategoryId: state => categoryId => {
      function findParentCategoryId (categoryList, targetId, parentId = 'main') {
        for (const category of categoryList) {
          if (category.categoryId === targetId) {
            return parentId
          }
          if (category.subCategory) {
            const result = findParentCategoryId(category.subCategory, targetId, category.categoryId)
            if (result) return result
          }
        }
        return null // targetId를 못 찾은 경우
      }
      return state.category && findParentCategoryId(state.category, categoryId)
    },
    getItemByItemId: state => collectionItemId => state.itemProperty[collectionItemId],
    getMyCollectionSetting: state => state.myCollectionSetting,
    // 마이콜렉션 카테고리바 구성에 필요한 배열
    getMyCollectionCategory: state => categoryId => {
      const myCollectionCategory = (state.myCollectionSetting && state.myCollectionSetting.category) || []
      return myCollectionCategory
    },
    getDetailGallery: state => state.detailGallery,
    getDetailVideo: state => state.detailVideo,
    getToastMessage: state => state.toastMessage,
    getMegaMenu: state => state.megaMenu,
    getIsMyCollectionItem: state => collectionItemId => {
      const myCollectionIds = state.myCollectionItemIds || []
      return collectionItemId && myCollectionIds.includes(collectionItemId)
    },
    getPageIdByOta: state => state.pageIdByOta,
    getCommonItemStyle: state => {
      const commons = state.collectionSetting && state.collectionSetting.collectionPage
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return commons && {
        ...commons.nameSpacing && {
          ...commons.nameSpacing && {
            name: `${spacingToLts(commons.nameSpacing)}em`
          },
          ...commons.descTop && {
            descTop: `${spacingToLts(commons.descTopSpacing)}em`
          },
          ...commons.descBottom && {
            descBottom: `${spacingToLts(commons.descBottomSpacing)}em`
          }
        }
      }
    }
  }
}